import {
  ModelCheckbox,
  ModelTextarea,
} from '@equifinance/shared';
import { formatDateTime } from '@equifinance/shared/utils';
import styled from 'styled-components';
import { PostOfferDecision, useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import {
  UnderwriterDecision,
  SubmitContainer,
  InfoPanel,
  SubmittedText,
  Divider,
} from '../../components/UnderwriterDecision';
import PostOfferActionsSection from './PostOfferActionsSection';
import PostOfferDatesSection from './PostOfferDatesSection';
import PostOfferDocumentsSection from './PostOfferDocumentsSection';

export const PostOfferRefName = 'post-offer';

const ButtonContainer = styled.div`
  width: fit-content;
`;

export default function PostOfferSection() {
  const { checklist } = useChecklistContext();

  const { postOffer } = checklist ?? {};

  const underwriterDecisionOptions = {
    ...(postOffer?.possibleDecisions?.reduce((options, decision) => ({
      ...options,
      [`${decision}`]: decision,
    }), {}) ?? {}),
    ...PostOfferDecision,
  };

  return (
    <PaddedGenericSection
      refName={PostOfferRefName}
      section={ChecklistSection.POST_OFFER}
      subSection={ChecklistSection.NOTES_POST}
      checklistItem={postOffer}
    >
      <PostOfferActionsSection />
      <PostOfferDatesSection />
      <PostOfferDocumentsSection />
      <UnderwriterDecision
        field="postOffer"
        options={underwriterDecisionOptions}
        required
        decisionDisabled={postOffer?.checklistIndicatorType === 'Locked' || postOffer?.submitted}
      />
      {postOffer?.decision === 'DocumentsReturnedUnableToComplete' && (
        <ModelTextarea
          field="postOffer.decisionDetails"
          label="Details"
          rows={2}
          disabled={postOffer?.checklistIndicatorType === 'Locked' || postOffer?.submitted}
        />
      )}
      <SubmitContainer>
        {postOffer?.submitted && postOffer?.submittedByName && postOffer?.submittedTimestamp && (
          <InfoPanel>
            <SubmittedText>
              {postOffer?.submittedByName}
            </SubmittedText>
            <Divider />
            <SubmittedText>
              {formatDateTime(postOffer?.submittedTimestamp, 'DD/MM/YYYY, HH:mm:ss')}
            </SubmittedText>
          </InfoPanel>
        )}
        <ButtonContainer>
          <ModelCheckbox
            label="Mark as complete"
            field="postOffer.submitted"
            disabled={!postOffer?.canSubmit || postOffer?.checklistIndicatorType === 'Locked'}
            successColor={postOffer?.submitted}
            isCompleteCheckbox
          />
        </ButtonContainer>
      </SubmitContainer>
    </PaddedGenericSection>
  );
}
